module.exports = __webpack_public_path__ + "img/invitation-to-register-for-portal-en.b5a9830.png";